module.exports = __webpack_public_path__ + "static/media/fonte.f0e106f8.jpg";